import axios from '@/axios';
export default (params) => axios.get('dashboard.chart2.dummy.json', {params});
